export default "__VITE_ASSET__CPHU0H5___";